import "./styles.css";

const partners = [
  ["Dra. Melissa França P. V. de Moraes", "OAB/MT 12.134", "/assets/melissa.webp"],
  ["Dr. Wagner V. de Moraes", "OAB/MT 9.668", "/assets/wagner.webp"],
];

const team = [
  ["Talia Soaresy Dias do Nascimento", "Advogada"],
  ["Dra. Suelen A. Wojciechowski Urbano", "Advogada"],
  ["Dr. André Luiz Ulhoa", "Advogado"],
  ["Dra. Sara Duarte da Silva", "Advogada"],
];

const values = [
  ["Missão", "Prestar serviços jurídicos com qualidade, atenção personalizada e compreensão real dos negócios dos clientes."],
  ["Visão", "Atuar como escritório de referência em soluções jurídicas empresariais, com técnica, ética e relacionamento próximo."],
  ["Valores", "Responsabilidade, sigilo, atualização constante, clareza na comunicação e compromisso com resultado jurídico sustentável."],
];

const areas = [
  ["Assessoria Jurídica à Empresa", "Assessoria jurídica completa a empresas, com atuação preventiva e contenciosa, protegendo patrimônio, reputação e relações comerciais."],
  ["Direito Público", "Atuação em temas administrativos, licitações, contratos públicos e relações com a Administração Pública."],
  ["Direito Bancário", "Defesa de interesses em operações financeiras, contratos bancários e cobranças indevidas."],
  ["Direito Contratual", "Elaboração, revisão e acompanhamento de contratos civis, empresariais e negociais."],
  ["Direito de Família e Sucessões", "Atendimento em divórcios, inventários, planejamento sucessório e proteção patrimonial."],
  ["Direito Previdenciário", "Orientação e acompanhamento em benefícios e demandas previdenciárias."],
  ["Direito Imobiliário", "Atuação em compra, venda, locação, regularização e conflitos imobiliários."],
  ["Direito Médico e Saúde", "Atendimento em demandas de saúde, responsabilidade médica e planos de saúde."],
  ["Direito Societário", "Constituição, reorganização e suporte jurídico para sociedades empresárias."],
  ["Direito Trabalhista", "Consultoria e defesa em relações de trabalho, tanto preventivas quanto contenciosas."],
  ["Direito Empresarial", "Suporte jurídico estratégico para empresas em temas contratuais, societários e regulatórios."],
  ["Licitação", "Acompanhamento de processos licitatórios, impugnações, recursos e contratos administrativos."],
  ["Lei Geral de Proteção de Dados", "Adequação à LGPD, políticas internas e governança de dados."],
  ["Planejamento Sucessório e Proteção de Bens", "Estruturas jurídicas para organização patrimonial e sucessória."],
  ["Recuperação Judicial e Falências", "Atuação em reestruturação empresarial, recuperação judicial e processos falimentares."],
  ["Direito Educacional", "Assessoria a instituições de ensino e resolução de conflitos educacionais."],
  ["Direito Criminal", "Defesa técnica em demandas criminais e acompanhamento processual."],
  ["Responsabilidade Civil", "Atuação em reparação de danos, indenizações e obrigações civis."],
  ["Eleitoral", "Atuação consultiva e contenciosa em temas eleitorais."],
  ["Direito Civil", "Acompanhamento em obrigações, contratos, família, sucessões e responsabilidade civil."],
  ["Direito Religioso", "Assessoria a organizações religiosas e temas institucionais correlatos."],
  ["Direito Ambiental", "Consultoria e defesa em licenciamento, autos de infração e responsabilidade ambiental."],
  ["Direito do Consumidor", "Defesa em relações de consumo e prevenção de riscos jurídicos."],
];

const awards = [
  "Prêmio Quality Justiça 2021",
  "Prêmio Empresa Brasileira do Ano 2019",
  "Prêmio Quality Diamante 2018",
  "Prêmio Master Águia - Melhores do Ano 2018",
  "Prêmio Águia Americana 2018",
  "Prêmio Latin American Quality Award 2018 e Medalha de Prata a Qualidade em Advocacia",
  "FALASP - Federação das Academias de Letras e Artes do Estado de São Paulo ao Dr. Wagner e Dra. Melissa",
  "Publicação sobre o escritório e sua qualificação a nível internacional nas revistas Quality Magazine N°208, 209 e 216.",
];

const publications = [
  ["Revista Quality nº 208", "/assets/wp-original/captura-de-tela-2021-02-03-as-17.29.29.png.webp"],
  ["Revista Quality nº 209", "/assets/wp-original/209-esp-46-e-47-min.png.webp"],
  ["Revista Quality nº 216", "/assets/wp-original/216-esp-60-61-min.png.webp"],
];

const contact = {
  email: "adm@francaemoraes.com.br",
  phone: "+55 65 99809-1198",
  phoneHref: "tel:+5565998091198",
  whatsapp: "https://api.whatsapp.com/send?phone=5565981460070&text=Ol%C3%A1,%20te%20encontrei%20no%20site%20Fran%C3%A7a%20%26%20Moraes%20-%20Advocacia%20e%20Consultoria%20Empresarial",
  instagram: "https://www.instagram.com/francaemoraesadvogados/",
  address: "Cuiabá - MT",
};

const blogArticle = {
  title: "Importância da Advocacia Tributária",
  image: "/assets/wp-original/importancia-da-advocacia-tributaria.jpeg.webp",
  paragraphs: [
    "A importância de ter um escritório especializado em direito tributário para sua empresa é inegável.",
    "Com o aumento da complexidade das leis fiscais e o risco de penalidades por parte da Receita Federal, é fundamental contar com uma equipe profissional capacitada e especializada.",
    "A atuação preventiva ajuda empresas a organizar rotinas, reduzir riscos e tomar decisões com mais segurança jurídica.",
  ],
};

function Header() {
  return (
    <header>
      <div className="topMini">Área do Cliente</div>
      <div className="navBar">
        <a href="/" className="brand"><img src="/assets/logo-topo.webp" alt="França & Moraes" /></a>
        <nav>
          <a href="/">Início</a>
          <a href="/#quem-somos">Quem Somos</a>
          <a href="/#missao-visao-valores">Missão, Visão e Valores</a>
          <a href="/#atuacao">Áreas de Atuação</a>
          <a href="/blog/">Blog</a>
          <a href="/#premios">Prêmios</a>
          <a href="/#publicacoes">Publicações</a>
          <a href="/area-do-cliente/">Área do Cliente</a>
          <a href="/#contato">Contato</a>
        </nav>
      </div>
    </header>
  );
}

function CookieBar() {
  return (
    <div className="cookie">Este site usa cookies para melhorar sua experiência. Ao continuar você aceita esta condição. <button>Ok</button></div>
  );
}

function FooterMini() {
  return (
    <footer className="footerMini">
      <span>Desenvolvido e Hospedado por</span>
      <span>Design and Branding by</span>
    </footer>
  );
}

function ContactChannels() {
  return (
    <div className="contactChannels">
      <a href={`mailto:${contact.email}`}>{contact.email}</a>
      <a href={contact.phoneHref}>{contact.phone}</a>
      <a href={contact.whatsapp} target="_blank" rel="noreferrer">WhatsApp</a>
      <a href={contact.instagram} target="_blank" rel="noreferrer">Instagram</a>
      <span>{contact.address}</span>
    </div>
  );
}

function ContactForm() {
  return (
    <form className="contactForm" action={`mailto:${contact.email}`} method="post" encType="text/plain">
      <div className="formGrid">
        <label>Nome<input name="nome" autoComplete="name" required /></label>
        <label>E-mail<input name="email" type="email" autoComplete="email" required /></label>
      </div>
      <label>Tipo de atendimento
        <select name="tipo" defaultValue="Consultivo">
          <option>Consultivo</option>
          <option>Contencioso</option>
          <option>Empresarial</option>
          <option>Área do cliente</option>
        </select>
      </label>
      <label>Arquivo<input name="arquivo" type="file" /></label>
      <label>Mensagem<textarea name="mensagem" rows={6} required /></label>
      <label>Captcha: quanto é 3 + 4?<input name="captcha" inputMode="numeric" pattern="7" required /></label>
      <button type="submit">Enviar mensagem</button>
    </form>
  );
}

function ContactPage() {
  return (
    <main>
      <Header />
      <section className="contactPage">
        <div>
          <h2>Contato</h2>
          <p>Fale com a equipe França & Moraes para atendimento jurídico empresarial e consultivo.</p>
          <ContactChannels />
          <a className="clientShortcut" href="/area-do-cliente/">Acessar Área do Cliente</a>
        </div>
        <ContactForm />
      </section>
      <FooterMini />
      <CookieBar />
    </main>
  );
}

function ClientAreaPage() {
  return (
    <main>
      <Header />
      <section className="clientPage">
        <h2>Área do Cliente</h2>
        <form className="loginBox" method="post" action="https://www.siteadv.com.br/francaemoraes/ExternalLogin.aspx?id=3995">
          <label>Login:<input name="login" required /></label>
          <label>Senha:<input type="password" name="senha" required /></label>
          <button type="submit">Entrar</button>
        </form>
      </section>
      <FooterMini />
      <CookieBar />
    </main>
  );
}

function BlogPage() {
  return (
    <main>
      <Header />
      <section className="blogPage">
        <div className="breadcrumb">Início / Blog</div>
        <article className="blogPostPreview">
          <img src={blogArticle.image} alt={blogArticle.title} />
          <span>3 anos atrás</span>
          <strong>Blog</strong>
          <h2>{blogArticle.title}</h2>
          <p>{blogArticle.paragraphs[0]} {blogArticle.paragraphs[1]}</p>
          <strong>ADVOCACIA TRIBUTÁRIA</strong>
          <a href="/blog/importancia-da-advocacia-tributaria/">Continuar lendo</a>
        </article>
        <aside className="blogSidebar">
          <h6>Filtro</h6>
          <input placeholder="Pesquisar por:" />
          <h2>Arquivos</h2>
          <p>março 2023 (1)</p>
          <div className="calendar">maio 2026<br />S T Q Q S S D<br />1 2 3 4 5 6 7 8 9 10<br />11 12 13 14 15 16 17</div>
        </aside>
      </section>
      <FooterMini />
      <CookieBar />
    </main>
  );
}

function BlogArticlePage() {
  return (
    <main>
      <Header />
      <article className="blogArticle">
        <div className="breadcrumb">Início / Blog / {blogArticle.title}</div>
        <img src={blogArticle.image} alt={blogArticle.title} />
        <span>Blog</span>
        <h1>{blogArticle.title}</h1>
        {blogArticle.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      </article>
      <FooterMini />
      <CookieBar />
    </main>
  );
}

function HomePage() {
  return (
    <main>
      <Header />

      <section className="hero">
        <img src="/assets/hero.webp" alt="França & Moraes Advocacia e Consultoria Empresarial" />
        <div>
          <h1>França & Moraes</h1>
          <p>Advocacia e Consultoria Empresarial</p>
          <a href="/area-do-cliente/">Área do Cliente</a>
        </div>
      </section>
      <CookieBar />

      <section id="quem-somos" className="aboutIntro">
        <div>
          <h2>Quem Somos</h2>
          <p><strong>França & Moraes Advocacia e Consultoria Empresarial</strong> é um escritório de advocacia fundado em 2010, com atuação voltada à prestação de serviços jurídicos de qualidade, de forma personalizada e exclusiva.</p>
          <p>A atuação parte da compreensão das expectativas dos clientes, dos negócios desenvolvidos por eles e do mercado em que estão inseridos.</p>
        </div>
        <img src="/assets/wp-original/dsc-5422-scaled.jpg.webp" alt="Ambiente do escritório França & Moraes" />
      </section>

      <section id="missao-visao-valores" className="values">
        {values.map(([title, text]) => (
          <article key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </section>

      <section className="people">
        <h2>Sócios</h2>
        <div className="partners">
          {partners.map(([name, register, image]) => (
            <article key={name}>
              <img src={image} alt={name} />
              <h3>{name}</h3>
              <span>{register}</span>
            </article>
          ))}
        </div>
        <h2>Equipe</h2>
        <div className="team">
          {team.map(([name, role]) => (
            <article key={name}>
              <h3>{name}</h3>
              <span>{role}</span>
            </article>
          ))}
        </div>
      </section>

      <section id="atuacao" className="areas">
        <h2>Áreas de atuação</h2>
        <div className="areaGrid">
          {areas.map(([title, text]) => (
            <article key={title}>
              <span>+</span>
              <div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="publicacoes" className="publications">
        <h2>Publicações</h2>
        <div>
          {publications.map(([title, image]) => (
            <article key={title}>
              <img src={image} alt={title} />
              <h3>{title}</h3>
            </article>
          ))}
        </div>
      </section>

      <section id="premios" className="awards">
        <h2>Prêmios</h2>
        <div>
          {awards.map((award) => (
            <article key={award}>
              <h3>{award}</h3>
            </article>
          ))}
        </div>
      </section>

      <section id="contato" className="homeContact">
        <div className="homeContactIntro">
          <h2>Contato</h2>
          <p>Atendimento jurídico empresarial e consultivo em Cuiabá-MT.</p>
          <ContactChannels />
        </div>
        <ContactForm />
      </section>
      <FooterMini />
    </main>
  );
}

function App() {
  const path = window.location.pathname;
  if (path.startsWith("/area-do-cliente")) return <ClientAreaPage />;
  if (path.startsWith("/contato")) return <ContactPage />;
  if (path.startsWith("/blog/importancia-da-advocacia-tributaria")) return <BlogArticlePage />;
  if (path.startsWith("/blog")) return <BlogPage />;
  return <HomePage />;
}

export default App;
